export default __webpack_public_path__ + "static/media/Levitate D7.3 Medium term impacts of CCAM on freight transport.f9a6b03c.pdf";